const elements = $('.opening-hours-autofill').toArray()

function triggerEvent(
    element,
    eventType,
    params = null,
    options = {
        bubbles: true,
        cancelable: true,
        detail: null
    }) {
    options.detail = params;
    const event = new CustomEvent(eventType, options);
    element.dispatchEvent(event);
}

function attach(element) {
    const inputs = Array.from(element.querySelectorAll('tr:not(:first-child) select'))
        .reduce((acc, element) => {
            if (!Array.isArray(acc[element.dataset.name])) {
                acc[element.dataset.name] = []
            }

            acc[element.dataset.name].push(element)

            return acc
        }, {})

    const masters = Array.from(element.querySelectorAll('tr:first-child select'))
    masters.forEach(element => element.previousValue  = element.value)

    masters.forEach(element => element.addEventListener('change', event => {
        const name = event.target.dataset.name
        const value = event.target.value
        const previousValue = event.target.previousValue
        event.target.previousValue = event.target.value

        if (!(name in inputs)) {
            return
        }

        inputs[name].forEach(element => {
            if (element.value === previousValue) {
                element.value = value
                triggerEvent(element, 'change')
            }
        })
    }))
}


elements.forEach(attach)
